import React, {Component} from 'react'
import {Alert, Select, Spin} from "antd"
import PropTypes from "prop-types"
import {listUserCut} from "../../../services/api/3dApi"

const {Option} = Select

// Dùng chung request đang chạy khi 1 màn có nhiều FilterUserCut (người cắt, người nhận cắt)
let pendingListUserCut = null

const fetchListUserCut = () => {
    if (!pendingListUserCut) {
        pendingListUserCut = listUserCut().then(
            (res) => {
                pendingListUserCut = null
                return res
            },
            (e) => {
                pendingListUserCut = null
                throw e
            }
        )
    }

    return pendingListUserCut
}

class FilterUserCut extends Component {
    state = {
        usersCut: this.props.usersCut,
        options: [],
        loading: false,
        error: ''
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                usersCut: this.props.usersCut
            })
        }
    }

    componentDidMount() {
        this._fetchListUserCut()
    }

    _handleChange = (value) => {
        const {onChangeUsersCut} = this.props

        if (typeof onChangeUsersCut === 'function') {
            onChangeUsersCut(value)
        }
    }

    _fetchListUserCut = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const {data: response} = await fetchListUserCut()
            const {data, success} = response

            if (!success) {
                return this.setState({
                    loading: false,
                })
            }

            const newData = Array.isArray(data) ? data.filter(Boolean) : []

            this.setState({
                loading: false,
                options: newData
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {usersCut, options, loading, error} = this.state
        const {placeholder} = this.props

        return (
            <div className="FilterProductType">
                {error ? <Alert message={error} type={'error'}/> :
                    <Spin spinning={loading}>
                        <Select
                            mode="multiple"
                            style={{width: '100%'}}
                            showArrow={true}
                            placeholder={placeholder}
                            defaultValue={usersCut}
                            onChange={this._handleChange}
                            value={usersCut}
                            allowClear
                        >
                            {
                                options.map((option, index) => {
                                    return <Option key={index} value={option}>{option}</Option>
                                })
                            }
                        </Select>
                    </Spin>
                }
            </div>
        )
    }
}

FilterUserCut.defaultProps = {
    loading: false,
    placeholder: 'Vui lòng chọn người cắt bạn muốn tìm kiếm',
}

FilterUserCut.propTypes = {
    loading: PropTypes.bool,
    usersCut: PropTypes.array,
    placeholder: PropTypes.string,
    onChangeUsersCut: PropTypes.func.isRequired
}

export default FilterUserCut
